import { Author } from '../api/Author';

const normalizePositiveInteger = (value: string): number | null => {
  const parsedValue = Number.parseInt(value.trim(), 10);

  return Number.isInteger(parsedValue) && parsedValue > 0 ? parsedValue : null;
};

const parseAdminIds = (raw: string | undefined): number[] => {
  if (!raw || !raw.trim()) {
    return [];
  }

  const parsedIds = raw
    .split(',')
    .map(normalizePositiveInteger)
    .filter((value): value is number => value !== null);

  return parsedIds;
};

export const getAdminAuthorIds = (): number[] => {
  return parseAdminIds(process.env.REACT_APP_ADMIN_AUTHOR_IDS);
};

export const isAdminAuthor = (
  author: Pick<Author, 'id'> | null | undefined
): boolean => {
  if (!author) return false;
  return getAdminAuthorIds().includes(author.id);
};
